import { useQuery } from "@tanstack/react-query";
import { Id } from "PFTypes";
import { QueryOptions } from "PFTypes/request_options";

import {
  fetchActivityEconomicsScenario,
  FetchActivityEconomicsScenarioResponse
} from "../../../services/activity";
import { activityKeys } from "./query_keys";

export const useActivityEconomicsScenario = (
  scenarioId: Id,
  options?: QueryOptions<FetchActivityEconomicsScenarioResponse, { status: number }>
) =>
  useQuery<FetchActivityEconomicsScenarioResponse, { status: number }>({
    queryKey: activityKeys.economicsScenario(scenarioId),
    queryFn: () => fetchActivityEconomicsScenario(scenarioId),
    retry: false,
    staleTime: 0,
    ...options
  });
